module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted vertical footer segment",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "ui left aligned container"
  }, [_c('div', {
    staticClass: "ui stackable inverted divided grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Noderīga informācija")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://api.memorywater.lv/files/ligums.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Līguma noteikumi")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://www.memorywater.com/lv/sakums#where-to-buy189",
      "target": "_blank"
    }
  }, [_vm._v("Kur nopirkt")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    on: {
      "click": _vm.showDeliveryZones
    }
  }, [_vm._v("Piegādes reģionu karte")]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted section divider"
  }), _vm._v(" "), _c('img', {
    staticClass: "ui left image",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/bv_logo_black_small.png"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticClass: "ui left image",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "/static/img/eu_logo.png"
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "five wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Kontakti")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("SIA BIOveikals, Reg/PVN nr.: LV40103164759, jur. adrese: Ziedlapas, Daugmales\n              pag., Ķekavas nov.")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "tel:37120010800"
    }
  }, [_vm._v("Tel.: +371 200 108 00")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "mailto:info@bioveikals.com"
    }
  }, [_vm._v("E-pasts: pasutit@bioveikals.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "five wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Sociālie tīkli")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://www.facebook.com/memorywater",
      "taget": "_blank"
    }
  }, [_c('i', {
    staticClass: "facebook square icon"
  }), _vm._v(" Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://twitter.com/MemoryWater",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "twitter square icon"
  }), _vm._v("\n              Twitter")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "delivery-zone3"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "image content"
  }, [_c('div', {
    staticClass: "ui  image"
  }, [_c('img', {
    attrs: {
      "src": "https://api.memorywater.lv/img/documents/piegades-teritorija.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui horizontal inverted small divided link list"
  }, [_c('p', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("© BIOveikals, 2024. Visas tiesības aizsargātas.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui horizontal inverted small divided link list"
  }, [_c('p', {
    staticClass: "item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LIAA Nr.9.2-17-L-2025/668")]), _vm._v(" "), _c('p', {
    staticClass: "item",
    staticStyle: {
      "display": "block",
      "padding-left": "0",
      "font-size": "0.8em",
      "max-width": "400px",
      "line-height": "1.5em",
      "text-align": "justify"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('b', [_vm._v("Atbalstāmā darbība:")]), _vm._v("\n\t\tkomercdarbības procesu uzlabošana, resursu pārvaldības jomā – specializēts risinājums uzņēmuma kurjera web-aplikācija pasūtījumu pārvaldībai."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Risinājums:")]), _vm._v("\n\t\tweb aplikācija."), _c('br'), _vm._v("\n\t\tProjekts ir saņēmis finansiālu atbalstu no "), _c('b', [_vm._v("ES atveseļošanas fonda.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted small divided link list"
  }, [_c('a', {
    attrs: {
      "href": "https://www.kurpirkt.lv/",
      "title": "Interneta veikalu cenas - Kurpirkt.lv"
    }
  }, [_c('img', {
    staticStyle: {
      "filter": "grayscale(100%)",
      "Border": "none"
    },
    attrs: {
      "alt": "Interneta veikalu cenas - Kurpirkt.lv",
      "src": "//www.kurpirkt.lv/media/kurpirkt88.gif",
      "width": "88",
      "height": "31"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.salidzini.lv/"
    }
  }, [_c('img', {
    staticStyle: {
      "filter": "grayscale(100%)",
      "border": "none"
    },
    attrs: {
      "alt": "salidzini.lv",
      "title": "Labākās cenas interneta veikalos",
      "src": "https://static.salidzini.lv/images/logo_button.gif",
      "width": "88",
      "height": "31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-144e10aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 321
// module chunks = 1